"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var FilePickerViewType;
(function (FilePickerViewType) {
    FilePickerViewType[FilePickerViewType["List"] = 0] = "List";
    FilePickerViewType[FilePickerViewType["Tile"] = 1] = "Tile";
})(FilePickerViewType = exports.FilePickerViewType || (exports.FilePickerViewType = {}));
// Used for ariaLabel and title (hover tooltip) of viewSwitcher icon.
exports.viewTypeDisplayStrings = (_a = {},
    _a[FilePickerViewType.List] = function () { return owa_mail_strings_1.default.ViewSwitcherListView_TitleText; },
    _a[FilePickerViewType.Tile] = function () { return owa_mail_strings_1.default.ViewSwitcherTileView_TitleText; },
    _a);
var _a;
//# sourceMappingURL=FilePickerViewSwitcher.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/types/FilePickerViewSwitcher.js
// module id = 1591
// module chunks = 2 3 43 106 107